// src/stores/authStore.js
import { defineStore } from "pinia";
import { AdminWS } from "@/services/AdminWS";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    // Initialize state from localStorage if available
    token: localStorage.getItem("token") || null,
    user: localStorage.getItem("user") ? localStorage.getItem("user") : null,
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
  },
  actions: {
    async login(username, password) {
      // eslint-disable-next-line no-useless-catch
      try {
        // Call the login method from AdminWS
        const data = await AdminWS.login(username, password);
        this.token = data.token;
        this.user = data.user || null;
        // Persist token and user in localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        console.log("Logged in as", this.user);
      } catch (error) {
        throw error;
      }
    },
    logout() {
      this.token = null;
      this.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});
